<template>
  <div>
    <div class="bg-hrad">
      <div class="container">
        <div class="header-mcct">
          <img width="156px" height="42px" src="@/assets/img/mynextpay-white.svg" />
          <h2 class="text-transform text-white">Upload file chứng từ theo yêu cầu</h2>
        </div>
      </div>
    </div>
    <section v-if="!licenceData.licenceId" class="login-area mix-dat">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <h2 class="text-center mb-5">Xác thực thông tin của bạn để upload chứng từ</h2>
            <div class="form-row">
              <div class="offset-sm-3 col-sm-6">
                <div class="login-form py-3">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(verifyLicense)">
                      <ValidationProvider rules="required" vid="email" name="Email/SDT">
                        <b-form-group slot-scope="{ errors }" label="Email/SDT">
                          <b-form-input
                            v-model="checkValue"
                            :state="errors[0] ? false : null"
                          ></b-form-input>
                          <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                      <div class="form-group">
                        <vue-recaptcha
                          @expired="captchaVerified = false"
                          @verify="
                            captchaVerified = true
                            errorMessage = ''
                          "
                          :sitekey="captchaKey"
                        />
                      </div>
                      <b-alert variant="danger" :show="errorMessage !== ''">{{
                        errorMessage
                      }}</b-alert>
                      <ul class="form-btn form-row m-t-20">
                        <li class="col-12">
                          <button type="submit" class="btn btn-success w-100" data-toggle="modal">
                            Xác nhận
                          </button>
                        </li>
                      </ul>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else class="container">
      <div class="breadcrumb-area p-0 pos-relative w-100">
        <h1>Upload file chứng từ theo yêu cầu</h1>
        <div style="float: right">
          <button
            v-if="canUpload"
            :disabled="
              (transFile.length == 0 &&
                transImage.length == 0 &&
                cardFile.length == 0 &&
                cardImage.length == 0) ||
              showLoading === true
            "
            @click="updateFile"
            class="btn btn-primary ml-2"
          >
            Lưu thông tin
          </button>
        </div>
      </div>
      <div class="card py-10 pt-15 b-t-1-869fb229 w-100">
        <div class="card-body form-row">
          <div class="col-sm-6 mb-3">
            <div class="form-detail">
              <h1>Thông tin chung của MC</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên merchant<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.merchantInfo && licenceData.merchantInfo.name }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Email<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.merchantInfo && licenceData.merchantInfo.email }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Số điện thoại<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.merchantInfo && licenceData.merchantInfo.mobile }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >MST/ ĐKKD<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{
                      licenceData.merchantInfo &&
                      licenceData.merchantInfo.businessRegistrationNumber
                    }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Địa chỉ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.merchantInfo && licenceData.merchantInfo.addressBiz }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Điểm chấp nhận thanh toán<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p
                    class="form-control-plaintext f12"
                    v-if="licenceData.merchantInfo && licenceData.merchantInfo.bizArea"
                  >
                    {{ licenceData.merchantInfo.bizArea.join(', ') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Sale phát triển<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p
                    class="form-control-plaintext f12"
                    v-if="licenceData.saleInfo && licenceData.saleInfo.name"
                  >
                    <span>{{ licenceData.saleInfo.name }}</span> -
                    <span> {{ licenceData.saleInfo.email }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="form-detail">
              <h1>Thông tin giao dịch MPOS</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Mã giao dịch MPOS<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.transInfo && licenceData.transInfo.tranTxnId }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Loại giao dịch<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.transInfo && licenceData.transInfo.tranTypeText }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Phương thức thanh toán<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.transInfo && licenceData.transInfo.paymentMethodText }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Trạng thái giao dịch<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  {{ licenceData.transInfo && licenceData.transInfo.statusText }}
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Loại rủi ro<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.requestTypeText }}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-detail">
              <h1>Thông tin thẻ thanh toán</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên chủ thẻ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.cardInfo && licenceData.cardInfo.holderName }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Số thẻ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.cardInfo && licenceData.cardInfo.number }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Loại thẻ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenceData.cardInfo && licenceData.cardInfo.type }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 mb-3">
            <div class="img-list-wrapper">
              <h1 class="form-inner-heading">Upload thông tin chứng từ</h1>
              <div>
                <div>
                  <h1 class="form-inner-heading">1. Chứng từ liên quan đến giao dịch</h1>
                  <i
                    >Hướng dẫn:
                    <ul class="b">
                      <li>
                        Nếu là giao dịch trực tiếp cần cung cấp: Hoá đơn bán lẻ, VAT, Phiếu thu,
                        Phiếu giao hàng, Phiếu xuất kho, Hợp đồng...
                      </li>
                      <li>
                        Nếu là giao dịch trực tuyến cần cung cấp: Hình ảnh tin nhắn, Sao kê trừ
                        tiền, File ghi âm, Mail trao đổi, Chứng từ xác nhận đã giao dịch, ...
                      </li>
                    </ul>
                  </i>
                  <br />
                  <UploadMultiple
                    @syncFile="syncFile"
                    :lsData="transFile"
                    :canUpload="canUpload"
                    fileType="file"
                    title="Upload file PDF, ghi âm, video, ..."
                    accept="application/pdf, audio/*, video/*"
                    :maxFile="4"
                    uniqueKey="transFile"
                  />
                  <UploadMultiple
                    @syncFile="syncFile"
                    :lsData="transImage"
                    :canUpload="canUpload"
                    uniqueKey="transImage"
                  />
                </div>
                <div>
                  <h1 class="form-inner-heading">2. Chứng từ liên quan đến thông tin chủ thẻ</h1>
                  <i
                    >Các thông tin cần cung cấp: Ảnh hộ chiếu, CMND/CCCD (Chụp 2 mặt), Hình ảnh
                    khách hàng giao dịch tại đơn vị, Hình ảnh trích xuất camera khách giao dịch,
                    Hình ảnh khách hàng tại cửa hàng
                  </i>
                  <br />
                  <UploadMultiple
                    @syncFile="syncFile"
                    :lsData="cardFile"
                    :canUpload="canUpload"
                    fileType="file"
                    title="Upload file PDF, ghi âm, video, ..."
                    accept="application/pdf, audio/*, video/*"
                    :maxFile="4"
                    uniqueKey="cardFile"
                  />
                  <UploadMultiple
                    @syncFile="syncFile"
                    :lsData="cardImage"
                    :canUpload="canUpload"
                    uniqueKey="cardImage"
                  />
                </div>
              </div>
              <button
                v-if="canUpload"
                :disabled="
                  (transFile.length == 0 &&
                    transImage.length == 0 &&
                    cardFile.length == 0 &&
                    cardImage.length == 0) ||
                  showLoading === true
                "
                @click="updateFile"
                class="btn btn-primary ml-2"
              >
                Lưu thông tin
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="bg-ef">
      <div class="container">
        <div class="footer-mcct">
          <p class="t">CÔNG TY CỔ PHẦN CÔNG NGHỆ VIMO</p>
          <p class="i">
            <i>Tầng 12A, toà nhà VTC Online, số 18 Tam Trinh, Phường Tương Mai, Hà Nội</i>
          </p>
          <p class="i"><i>Hotline: 1900.63.69.56 | Email: hotro@nextpay.vn</i></p>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueCompositionAPI from '@vue/composition-api'
  import { VueRecaptcha } from 'vue-recaptcha'
  import { LicenceService } from '@/services/licence.service'
  import Config from '@/thirdParty/config'
  import { v4 as uuidv4 } from 'uuid'
  import UploadMultiple from '../../components/UploadMultiple.vue'
  Vue.use(VueCompositionAPI)
  export default {
    data() {
      return {
        captchaKey: window._env_?.VUE_APP_CAPTCHA_KEY ?? process.env.VUE_APP_CAPTCHA_KEY,
        Config,
        licenceData: {},
        showLoading: false,
        captchaVerified: false,
        errorMessage: '',
        checkValue: '',
        fileUploads: [],
      }
    },
    components: { VueRecaptcha, UploadMultiple },
    computed: {
      transFile: vm => vm.fileUploads.filter(s => s.type === 'transFile'),
      transImage: vm => vm.fileUploads.filter(s => s.type === 'transImage'),
      cardFile: vm => vm.fileUploads.filter(s => s.type === 'cardFile'),
      cardImage: vm => vm.fileUploads.filter(s => s.type === 'cardImage'),
      canUpload: vm => ['NO_PROVIDE', 'REJECT', 'DIRECTOR_REJECT'].includes(vm.licenceData.status),
    },
    methods: {
      async verifyLicense() {
        if (this.captchaVerified === false) {
          this.errorMessage = 'Bạn chưa xác thực CAPTCHA'
          return
        } else this.errorMessage = ''
        try {
          this.showLoading = true
          const res = await LicenceService.checkMerchant({
            checkValue: this.checkValue.trim(),
            licenceId: this.$route.params.licenceId,
          })
          if (res.data.valid === true) {
            this.errorMessage = ''
            await this.getDetailMerchant()
          } else this.errorMessage = 'Xác thực thông tin thất bại.'
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async getDetailMerchant() {
        const resLicense = await LicenceService.detailMerchant({
          licenceId: this.$route.params.licenceId,
        })
        this.licenceData = resLicense.data.licence
        this.fileUploads = []
        const mappingData = (arr, type) =>
          arr.forEach(url => {
            const ar = { name: url, url, type, id: uuidv4() }
            this.fileUploads.push(ar)
          })
        mappingData(this.licenceData.licenceTransactionUrls, 'transFile')
        mappingData(this.licenceData.licenceTransactionUrlsImg, 'transImage')
        mappingData(this.licenceData.licenceCardOwnerUrls, 'cardFile')
        mappingData(this.licenceData.licenceCardOwnerUrlsImg, 'cardImage')
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('file', item.file)
          const data = await LicenceService.uploadFileMerchant(formData)
          const urlFile = data.data.urlFile
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
      async totalSubmit() {
        const allPromises = this.fileUploads.map(s => this.sendFile(s))
        return Promise.all(allPromises).then(res => {
          const returnData = {
            licenceTransactionUrls: [],
            licenceTransactionUrlsImg: [],
            licenceCardOwnerUrls: [],
            licenceCardOwnerUrlsImg: [],
          }
          res.forEach(s => {
            if (s?.urlFile) {
              if (s.type === 'transFile') {
                returnData.licenceTransactionUrls.push(s.urlFile)
              }
              if (s.type === 'transImage') {
                returnData.licenceTransactionUrlsImg.push(s.urlFile)
              }
              if (s.type === 'cardFile') {
                returnData.licenceCardOwnerUrls.push(s.urlFile)
              }
              if (s.type === 'cardImage') {
                returnData.licenceCardOwnerUrlsImg.push(s.urlFile)
              }
            }
          })
          return returnData
        })
      },
      syncFile(files, uniqueKey) {
        this.fileUploads = this.fileUploads.filter(s => s.type !== uniqueKey)
        this.fileUploads.push(...files)
      },
      async updateFile() {
        try {
          this.showLoading = true
          const params = await this.totalSubmit()
          const data = await LicenceService.updateUrl({
            ...params,
            licenceId: this.$route.params.licenceId,
            isMcUpdate: true,
          })
          if (data.success) {
            await this.getDetailMerchant()
            this.showSuccessMx('Upload file chứng từ thành công')
          } else {
            this.showFailMx(data.message)
          }
        } catch (e) {
          this.showFailMx('Upload file chứng từ thất bại')
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .header-mcct {
    padding: 25px 0;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    h2 {
      font-size: 32px;
      text-align: center;
    }
    img {
      display: none;
    }
  }
  .bg-hrad {
    background-color: #3979b5;
  }
  .bg-ef {
    background-color: #efefef;
  }
  .footer-mcct {
    padding: 25px 0;
    display: flex;
    flex-direction: column;
    p {
      line-height: normal;
    }
    .i {
      font-size: 11px;
    }
  }
  @media (min-width: 768px) {
    .header-mcct {
      img {
        display: block;
      }
      h2 {
        font-size: 36px;
      }
    }
  }
</style>
